import React from 'react'
import {Link} from 'gatsby'

import SlackLink from '../slack-link'
import footerLogo from '../../../img/8th-wall-footer-logo.png'
import VrArLogo from '../../../img/VR_AR_logo_1x.png'
import footerLogoWebp from '../../../img/8th-wall-footer-logo.webp'
import VrArLogoWebp from '../../../img/VR_AR_logo_1x.webp'

export default () => (
  <section className='container-fluid section8 dark footer'>

    <div className='row siteMap'>
      <div className='col-lg-2 col-sm-12' />
      <div className='col-lg col-sm-12'>
        <picture>
          <source type='image/webp' srcSet={footerLogoWebp} />
          <img
            src={footerLogo}
            alt='8th Wall Logo'
            style={{maxWidth: '8em', height: 'auto', marginBottom: '3.5em'}}
          />
        </picture>
      </div>
      <div className='col-lg col-md-6 col-sm-12'>
        <ul>
          <p>8th Wall</p>
          <li><Link to='/pricing' a8='click;footer;go-to-pricing'>Pricing</Link></li>
          <li><Link to='/products-web' a8='click;footer;go-to-features'>Features</Link></li>
          <li><Link to='/faq' a8='click;footer;go-to-faq'>FAQ</Link></li>
          <li><a href='/login' a8='click;footer;login'>Log In</a></li>
        </ul>
      </div>

      <div className='col-lg col-md-6 col-sm-12'>
        <ul>
          <p>Learn</p>
          <li><a href='https://docs.8thwall.com/' a8='click;footer;go-to-docs'>Docs</a></li>
          <li><Link to='/tutorials' a8='click;footer;go-to-tutorials'>Tutorials</Link></li>
          <li><a href='https://github.com/8thwall/web' a8='click;footer;go-to-git-hub'>GitHub</a></li>
        </ul>
      </div>

      <div className='col-lg col-md-6 col-sm-12'>
        <ul>
          <p>Community</p>
          <li><SlackLink a8='click;footer;go-to-developer-slack'>Developer Slack</SlackLink></li>
          <li><a href='/blog' a8='click;footer;go-to-blog'>Blog</a></li>
          <li><Link to='/resources' a8='click;footer;go-to-support'>Support</Link></li>
        </ul>
      </div>

      <div className='col-lg col-md-6 col-sm-12'>
        <ul>
          <p>Company</p>
          <li><Link to='/company' a8='click;footer;go-to-about'>About</Link></li>
          <li>
            <a href='https://www.8thwall.com/partners' a8='click;footer;go-to-partners'>
              Partners
            </a>
          </li>
          <li><Link to='/careers' a8='click;footer;go-to-careers'>Careers</Link></li>
          <li><Link to='/contact' a8='click;footer;go-to-contact'>Contact</Link></li>
          <li><Link to='/press' a8='click;footer;go-to-press'>Press</Link></li>
        </ul>
      </div>

      <div className='col-lg-2 col-sm-12' />

    </div>

    <div className='row justify-content-center text-center' style={{marginBottom: '3em'}}>
      <div className='col-lg-2 col-sm-12' />
      <div className='col-lg col-sm-12'>
        <p className='footer-links'>
          <a href='https://twitter.com/the8thwall' a8='click;footer;go-to-twitter'>Twitter</a>
          {'  |  '}
          <a href='https://www.youtube.com/8thwall' a8='click;footer;go-to-you-tube'>YouTube</a>
          {'  |  '}
          <a
            href='https://www.facebook.com/the8thwall'
            a8='click;footer;go-to-facebook'
          >Facebook</a>
          {'  |  '}
          <a
            href='https://www.instagram.com/8thwall/'
            a8='click;footer;go-to-instagram'
          >Instagram</a>
          {'  |  '}
          <a
            href='https://www.linkedin.com/company/8thwall/'
            a8='click;footer;go-to-linked-in'
          >LinkedIn</a>
        </p>
      </div>
      <div className='col-lg-2 col-sm-12' />
    </div>

    <div className='row justify-content-center'>
      <div className='col-lg-2 col-sm-12' />
      <div className='col-lg col-sm-12 footer-links'>
        <div>Copyright © 2020, 8th Wall Inc.</div>
        <p>
          Our <Link to='/terms' a8='click;footer;go-to-terms'>Terms &amp; Conditions</Link>, <Link
          to='/privacy' a8='click;footer;go-to-privacy'>Privacy Policy</Link>, and <Link
          to='/copyright-dispute-policy' a8='click;footer;go-to-copyright-dispute'>Copyright Dispute
          Policy</Link>
        </p>
      </div>
      <div className='col-lg col-sm-12 text-right'>
        <a href='http://www.thevrara.com/' target='_blank' rel='noopener' a8='click;footer;go-to-the-vrara'>
          <picture>
            <source type='image/webp' srcSet={VrArLogoWebp} />
            <img style={{maxWidth: '10em'}} src={VrArLogo} alt='VR/AR Association member' />
          </picture>
        </a>
      </div>
      <div className='col-lg-2 col-sm-12' />
    </div>
  </section>
)
